import { Pipe } from '@angular/core';
import { KompaktdarstellungPipe } from '../kompakt-darstellung.pipe';
import { CapititelEntryMeta } from '../../../core/gb-api';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { PlatformLocation } from '@angular/common';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { KompaktAmtnummerPipe } from '../amt/kompakt-amtnummer-pipe';

@Pipe({
  name: 'kompaktCapititel'
})
export class KompaktCapititelPipe extends KompaktdarstellungPipe<CapititelEntryMeta> {
  constructor(
    protected formatService: FormatConfigService,
    protected location: PlatformLocation,
    protected componentLocation: ComponentLocationStrategy,
    protected amtnummerPipe: KompaktAmtnummerPipe
  ) {
    super(formatService, 'CAPITITEL', location, componentLocation);
  }

  transform(item: CapititelEntryMeta): string {
    if (!item) {
      return '';
    }
    let text = '';
    const delimiter = '-';
    if (this.formatElement === 'CAPITITEL_TYP00') {
      const amtnummer = this.amtnummerPipe.transform(item.erstellAmtNummer);
      text = amtnummer + [item.titelJahr, item.titelIndex].join(delimiter);
    }
    return text;
  }
}
